import { render, staticRenderFns } from "./ConfirmReleaseStudentModal.vue?vue&type=template&id=2d605ca0&scoped=true&"
import script from "./ConfirmReleaseStudentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmReleaseStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReleaseStudentModal.vue?vue&type=style&index=0&id=2d605ca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d605ca0",
  null
  
)

export default component.exports